/*
* 操作日志管理组件
* 优化时间：2026-08-04
*/

import CNF from '../../incs/Config.js';
import {
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';

import { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import {
    theme,
    message,
    Table,
    Input,
    Select,
    Space,
} from 'antd';

const { Option } = Select;

// 子组件：表格列表
const Lists = ({ dataLists, currentIndex, pageCount, changeIndex, loading }) => {
    const { token: { pageSize } } = theme.useToken();

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4 },
        { title: '操作者', dataIndex: 'operation', key: 'operation', fixed: 'left', width: 150, },
        { title: '操作对象', dataIndex: 'instance', key: 'instance', width: 300, },
        { title: '模块', dataIndex: 'module', key: 'module', width: 200, },
        { title: 'LDAP', dataIndex: 'ldap', key: 'ldap', width: 80, },
        { title: '动作', dataIndex: 'action', key: 'action', width: 120, },
        {
            title: '描述', key: 'description', ellipsis: true,
            render: (record) => record.description || '-'
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
            sorter: (a, b) => Date.parse(a.create_time) - Date.parse(b.create_time),
            width: CNF.tableCreateTimeColumnWidth + 60
        },
    ], []);

    return (
        <Table
            columns={columns}
            size='middle'
            dataSource={dataLists}
            // loading={loading}
            showSorterTooltip={{ target: 'sorter-icon' }}
            pagination={{
                showSizeChanger: false,
                showQuickJumper: false,
                showTotal: () => `共${pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条`,
                pageSize: pageSize,
                current: currentIndex,
                total: pageCount,
                onChange: (current) => changeIndex(current),
            }}
        />
    );
};

// 主组件
const LogOperation = ({ btnLists }) => {
    const { token: { pageSize, messageDuration } } = theme.useToken();

    // 状态定义
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);

    // 搜索字段
    const [operation, setOperation] = useState('');
    const [instance, setInstance] = useState('');
    const [module, setModule] = useState('');
    const [action, setAction] = useState('');

    useEffect(() => {
        setLoading(true);

        let params = {
            operation: operation,
            instance: instance,
            module: module,
            action: action,
            page_size: pageSize,
            current_index: currentIndex
        };

        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}logs/operations${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                message.error(data.msg, messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [pageSize, currentIndex, messageDuration, messageApi, operation, instance, module, action]);

    // 事件处理函数
    const handleOperationChange = useCallback((e) => {
        setOperation(e.target.value);
        setCurrentIndex(1); // 搜索时重置页码
    }, []);

    const handleInstanceChange = useCallback((e) => {
        setInstance(e.target.value);
        setCurrentIndex(1); // 搜索时重置页码
    }, []);

    const handleModuleChange = useCallback((value) => {
        setModule(value || '');
        setCurrentIndex(1); // 搜索时重置页码
    }, []);

    const handleActionChange = useCallback((value) => {
        setAction(value || '');
        setCurrentIndex(1); // 搜索时重置页码
    }, []);

    const handleIndexChange = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    // 生成模块选项
    const moduleOptions = useMemo(() => {
        const options = [];
        Object.keys(CNF.navItems).forEach((key) => {
            const item = CNF.navItems[key];
            if (item.submenu) {
                item.submenu.forEach(sub => {
                    if (sub.isLogModule && btnLists?.indexOf(sub.ptn) >= 0) {
                        options.push(<Option key={sub.ptn} value={sub.name}>{sub.name}</Option>);
                    }
                });
            } else if (item.isLogModule && btnLists?.indexOf(item.ptn) >= 0) {
                options.push(<Option key={item.ptn} value={item.name}>{item.name}</Option>);
            }
        });
        return options;
    }, [btnLists]);

    // 生成动作选项
    const actionOptions = useMemo(() => {
        return Object.keys(CNF.actionName).map((key) => {
            const actionName = CNF.actionName[key];
            if (btnLists?.indexOf(key.toLowerCase()) > -1) {
                return <Option key={key} value={actionName}>{actionName}</Option>;
            }
            return null;
        }).filter(Boolean);
    }, [btnLists]);

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    onChange={handleOperationChange}
                    placeholder='操作者'
                    value={operation}
                    allowClear
                />
                <Input
                    onChange={handleInstanceChange}
                    placeholder='操作对象'
                    value={instance}
                    allowClear
                />
                <Select
                    allowClear
                    placeholder='模块'
                    style={{ width: '100%', minWidth: 120, }}
                    popupMatchSelectWidth={false}
                    onChange={handleModuleChange}
                    value={module || undefined}
                >
                    {moduleOptions}
                </Select>
                <Select
                    allowClear
                    placeholder='动作'
                    style={{ width: '100%', minWidth: 80, }}
                    popupMatchSelectWidth={false}
                    onChange={handleActionChange}
                    value={action || undefined}
                >
                    {actionOptions}
                </Select>
            </Space>
            <Lists
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={handleIndexChange}
                loading={loading}
            />
        </>
    );
};

export default LogOperation;